<button #btn class="btn btn-light pb-1 pt-1 " (click)="ToggleFaveStar(!isFavorite)" [ngClass]="isFavorite ? 'Faved' : 'NotFaved'">
  <fa-icon [icon]="isFavorite ? faBookmarkSolid : faBookmarkRegular">Favorite</fa-icon>
</button>
